export interface CompleteProvisionalAccountRequest {
  lastName: string;
  phone: string;
  dateOfBirth: string;
  password: string;
}

export interface OtpVerifyResponse {
  token: string;
  userId: number;
  email: string;
  firstName?: string;
  lastName?: string;
}
